import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@babackapp/ui/components/dialog";

import { useState } from "react";
import { TemplatesList } from "./templates-list";

type TemplateListDialogProps = React.PropsWithChildren<{}>;

export function TempalteListDialog({ children }: TemplateListDialogProps) {
  const [open, setOpen] = useState(false);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>{children}</DialogTrigger>
      <DialogContent className="overflow-visible">
        <DialogHeader>
          <DialogTitle>Template List</DialogTitle>
          {/*<DialogDescription>Template List</DialogDescription>*/}
        </DialogHeader>

        <TemplatesList
          onTemplateClick={() => setOpen(false)}
          onTemplateCreated={() => setOpen(false)}
          className="max-h-[600px] overflow-auto no-scrollbar"
        />
      </DialogContent>
    </Dialog>
  );
}
